import React from 'react'
import PropTypes from 'prop-types'

const ExperienceTypeLookup = {
  MENTION: 'Mentions',
  REMINDER: 'Reminder',
  MOSAIC: 'Photo Mosaic',
  COMPETITION: 'Competition'
}

const WidgetStatusClassLookup = {
  draft: 'grey-salt',
  scheduled: 'blue-soft',
  active: 'green-jungle',
  paused: 'yellow',
  expired: 'red-soft',
  archived: 'grey-cascade'
}

const ExperienceNameAndStatus = ({
  name,
  status,
  type,
  startDate,
  endDate
}) => {
  const statusToLowerCase = status.toLowerCase()
  return (
    <div className='br-experience-name-type'>
      <label
        className={
          'br-experience-status label small ' +
          WidgetStatusClassLookup[statusToLowerCase]
        }
      >
        {statusToLowerCase}
      </label>

      <div
        className='br-experience-name font-blue-sharp bold uppercase'
        title={name}
      >
        {name}
      </div>
      <div className='br-experience-name font-blue-sharp'>
        Start Date: {startDate}
      </div>
      <div className='br-experience-name font-blue-sharp'>
        End Date: {endDate}
      </div>

      <div className='br-experience-type'>{ExperienceTypeLookup[type]}</div>
    </div>
  )
}

ExperienceNameAndStatus.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  type: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string
}

ExperienceNameAndStatus.displayName = 'ExperienceNameAndStatusComponent'

export default ExperienceNameAndStatus



// WEBPACK FOOTER //
// ./src/pages/my-experiences/experience/experience-name-and-status/index.js